import { COMMON_BUS_COMPONENTS_LIST } from '@/constants/commonBusComponentsList';
import BREAKPOINTS from '@/constants/breakpoints';
const ghostHeights = {};
for (const item of COMMON_BUS_COMPONENTS_LIST) {
    ghostHeights[item.name] = 0;
}
const namespaced = true;
class State {
    constructor() {
        this.ghostHeights = ghostHeights;
        this.mainPageContainerHeight = +BREAKPOINTS.MIN_CONTAINER_HEIGHT_DESKTOP;
    }
}
const getters = {
    getGhostHeights: state => state.ghostHeights,
    getMainPageContainerHeight: state => state.mainPageContainerHeight
};
const actions = {};
const mutations = {
    setGhostHeight(state, payload) {
        state.ghostHeights[payload.name] = payload.value;
    },
    setMainPageContainerHeight(state, payload) {
        state.mainPageContainerHeight = payload;
    }
};
export default {
    namespaced,
    state: new State(),
    getters,
    actions,
    mutations
};
